export default class OpenClose {
    constructor() {
        this.sections = document.querySelectorAll('.components-block-open-close');
        this.accordionHeaders = [];

        this.sections.forEach((section) => {
            const headers = section.querySelectorAll('.accordion-header');
            this.accordionHeaders.push(...headers);
        });

        this.ready();
    }

    ready() {
        this.accordionHeaders.forEach((header) => {
            header.addEventListener('click', function () {
                const accordionContent = header.parentElement.querySelector('.accordion-content');
                let accordionMaxHeight = accordionContent.style.maxHeight;

                if (accordionMaxHeight == '0px' || accordionMaxHeight.length == 0) {
                    accordionContent.style.maxHeight = `${accordionContent.scrollHeight + 32}px`;
                    header.dataset.open = true;
                } else {
                    accordionContent.style.maxHeight = `0px`;
                    header.dataset.open = false;
                }
            });
        });
    }
}

if (document.querySelector('.components-block-open-close')) {
    new OpenClose();
}
